import React from 'react';
import intl from 'react-intl-universal';

import {useDsManager, useRootStore} from '@stores/AppStateContext';
import {useBasicDataSourceDeps} from '../../../platform/hooks/useDataSourceDependencies';
import type {Issue} from '../../../stores/reliability/types';
import {deleteIssue} from '../../../actions/issue/deleteIssue';
import {ModalConfirm} from '../../components/ModalConfirm/ModalConfirm';

export interface IssueDeleteConfirmModalProps {
    issue: Issue | null;
    onClose: () => void;
}

export const IssueDeleteConfirmModal = ({issue, onClose}: IssueDeleteConfirmModalProps) => {
    const rootStore = useRootStore();
    const dsManager = useDsManager();
    const dsDeps = useBasicDataSourceDeps();
    const wsId = rootStore.view.workspace?.id;
    const issueTitle = issue?.title || intl.get('issues.delete.untitled').d('Untitled');

    const handleDelete = async () => {
        if (!issue || !wsId) return;
        await deleteIssue(dsDeps.dataClientService, dsDeps.authService, wsId, issue.id);
        onClose();
        dsManager?.getIssueDS(wsId).removeIssue(issue.id);
    };

    return (
        <ModalConfirm
            open={!!issue}
            type={'danger'}
            header={intl.get('issues.delete.header').d('Delete issue')}
            confirmText={intl.get('common.delete').d('Delete')}
            onConfirm={handleDelete}
            onCancel={onClose}
            onClose={onClose}
            isMobileBottomSheet
        >
            <div className="body-medium">
                {intl.getHTML('issues.delete.body', {issueTitle})
                    .d(`Are you sure you want to delete <b>“{issueTitle}”</b>? This cannot be undone.`)}
            </div>
        </ModalConfirm>
    );
};
